import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OktaAuthGuard, OktaCallbackComponent} from '@okta/okta-angular'

export const routes: Routes = [
  { path: 'callback', component: OktaCallbackComponent },
  {
    path: 'editor',
    loadComponent: () =>
      import('./views/pages/editor/document-template-editor.component').then(
        (m) => m.DocumentTemplateEditorComponent
      ),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: '',
    canActivate: [OktaAuthGuard],
    loadChildren: () =>
      import('./views/pages/layout.module').then((m) => m.LayoutModule),
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
